module.exports = __webpack_public_path__ + "img/Data Explorer Guide.pdf";